<!-- Toast de Notificação no TOPO -->
<div
  *ngIf="notification"
  [class]="getContainerClasses()"
  role="alert"
  aria-live="polite"
>
  <div
    class="notification-toast w-full max-w-[calc(100vw-2rem)] sm:max-w-xl rounded-lg border px-4 py-3 shadow-[0_10px_30px_rgba(15,23,42,0.12)] flex items-start gap-3 justify-between"
    [ngClass]="{
      'bg-[#d9f2e8] border-[#bde8d8] text-[#2d7f67]': notification.type === 'success',
      'bg-[#fee8e8] border-[#fdd0d0] text-[#c53030]': notification.type === 'error',
      'bg-[#fef8e8] border-[#fde8a8] text-[#b77f00]': notification.type === 'warning',
      'bg-[#e8f0ff] border-[#d0e0ff] text-[#0051ba]': notification.type === 'info'
    }"
  >
    <!-- Conteúdo -->
    <div class="flex-1 min-w-0">
      <p *ngIf="notification.title && !notification.hideTitle" class="font-semibold text-sm leading-[1.35] mb-1">{{ notificationTitle }}</p>
      <div class="space-y-1">
        <p *ngFor="let line of notificationMessageLines" class="text-sm leading-[1.55] font-medium text-balance" style="overflow-wrap: break-word; word-break: break-word;">
          <ng-container *ngFor="let segment of line">
            <span [ngClass]="segment.emphasis ? 'rounded bg-black/5 px-1 py-[1px] font-semibold tracking-[0.01em] break-all' : ''">{{ segment.text }}</span>
          </ng-container>
        </p>
      </div>
    </div>

    <!-- Botão fechar -->
    <button
      (click)="close()"
      class="h-6 w-6 rounded-md hover:bg-black/10 transition-colors flex items-center justify-center flex-shrink-0 mt-0.5"
      [ngClass]="{
        'text-[#2d7f67] hover:bg-[#2d7f67]/10': notification.type === 'success',
        'text-[#c53030] hover:bg-[#c53030]/10': notification.type === 'error',
        'text-[#b77f00] hover:bg-[#b77f00]/10': notification.type === 'warning',
        'text-[#0051ba] hover:bg-[#0051ba]/10': notification.type === 'info'
      }"
      aria-label="Fechar notificação"
      type="button"
    >
      <lucide-icon name="x" class="w-4 h-4"></lucide-icon>
    </button>
  </div>
</div>
